import LogoMark from '@/assets/images/Logo_TC_mark.svg?react';

// Лоадер telecom (макет, раздел 7): кольцо — серый трек и дуга цветом акцента,
// линейное вращение. Подписи «Загружаем данные» / «Загрузка» из макета нет
// (решение 24.09: кольцо и так читается как загрузка).
export const LoaderImage = () => (
  <div className="flex justify-center">
    <span
      aria-hidden="true"
      className="block size-9 animate-spin rounded-full border-[3px] border-solid border-line-subtle border-t-action-primary [animation-duration:0.8s]"
    />
  </div>
);

// Загрузчик страницы — пока проверяется вход и каркаса ещё нет: знак TC в
// большом белом кольце на той же красной волне, что у входа (токены экрана
// входа — фон гостевых страниц).
export const LoaderPage = () => (
  <div
    className="flex min-h-screen items-center justify-center bg-surface-auth-page bg-cover bg-center"
    style={{ backgroundImage: 'var(--auth-bg-image)' }}
  >
    <div className="relative flex size-28 items-center justify-center sm:size-[136px]">
      <span
        aria-hidden="true"
        className="absolute inset-0 animate-spin rounded-full border-4 border-solid border-white/20 border-t-white [animation-duration:1.1s]"
      />
      <LogoMark aria-hidden="true" className="h-11 w-auto text-white sm:h-[54px]" />
    </div>
  </div>
);
